import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Markdown from '../../../components/Markdown';
import Placeholder from '../../../components/Placeholder';

import { Section, SectionInner, ContentWrapper, Subtitle, Title, Text, HeroText } from './SeminarScheduleHero.style';

const SeminarScheduleHero = ({ data }) => (
  <Section>
    <SectionInner>
      <ContentWrapper>
        {data.hero ? (<Markdown src={data.hero} Component={HeroText} />) : (<Placeholder w="70%" pb="10%" />)}
      </ContentWrapper>      
      {/*
      <ContentWrapper>
        <Subtitle>
          <FormattedMessage id="professional_seminars" defaultMessage="Professional Seminars" />
        </Subtitle>
        <Title>
          <FormattedMessage id="learn_from_beauty_creators" defaultMessage="Learn from the beauty creators" />
        </Title>
        <Text>
          <FormattedMessage
            id="professional_seminars_hero_description"
            defaultMessage="At Shiseido, beauty is not an image, it is a feeling and when it is shared, we imagine a world that is, quite
          simply put, better. We appreciate beauty in diversity and throughout all of humankind. We realize there is
          still unpleasantness to be found."
          />
        </Text>
      </ContentWrapper>
      */}
    </SectionInner>
  </Section>
);

SeminarScheduleHero.defaultProps = {
  data: {
    hero: {
      description: undefined,
    },
  },
};

SeminarScheduleHero.propTypes = {
  data: PropTypes.shape(),
};

export default SeminarScheduleHero;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarScheduleHero/SeminarScheduleHero.js